import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Container,
    Stack,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { sectionSubtitleSx, sectionTitleSx } from "./homeStyles";

function HomeFaq() {
    const faqItems = [
        {
            q: "Можно ли загружать несколько PDF одновременно?",
            a: "Да. Qarzhy поддерживает одновременную загрузку нескольких PDF-файлов и нескольких групп документов. Система автоматически определяет банк, выполняет предварительный анализ и подготавливает корректные документы к дальнейшей обработке.",
        },
        {
            q: "Можно ли работать с несколькими организациями?",
            a: "Да. Сервис подходит для работы с несколькими организациями и филиалами. Количество доступных БИН зависит от тарифа, при этом основной функционал системы остается одинаковым.",
        },
        {
            q: "Какие сценарии обработки доступны в системе?",
            a: "Qarzhy поддерживает три основных сценария: сверку банковских платежных поручений с бухгалтерским учетом, сверку с кадровыми данными и формирование структурированного списка сотрудников и выплат без сверки.",
        },
        {
            q: "Какие расхождения система выявляет автоматически?",
            a: "Система автоматически определяет ключевые статусы: «НЕТ В УЧЕТЕ», «НЕТ В БАНКЕ», «РАЗНИЦА», «РАЗНЫЕ СЧЕТА», «РАЗНОЕ РАСПРЕДЕЛЕНИЕ СУММ», «НЕСКОЛЬКО СЧЕТОВ», «РАЗНЫЕ ФИО», «НЕСКОЛЬКО ФИО», а также кадровые расхождения. Результаты сортируются по критичности и выделяются цветом.",
        },
        {
            q: "Можно ли использовать результаты для внутреннего контроля и аудита?",
            a: "Да. Qarzhy подходит для бухгалтерии, финансовых подразделений, кадровых служб, внутреннего и внешнего аудита, комплаенс-проверок и экономической безопасности.",
        },
        {
            q: "Можно ли выгружать результаты в Excel?",
            a: "Да. После обработки Qarzhy сначала показывает результат непосредственно в интерфейсе системы: итоговые показатели, статусы и детализацию по сотрудникам, суммам, счетам и ФИО. При необходимости пользователь может скачать эти данные в виде Excel-отчета по кнопке «Скачать Excel».",
        },

        {
            q: "Сохраняются ли в системе персональные данные из банковских документов?",
            a: "Qarzhy не предназначен для долговременного хранения банковских документов и персональных данных как отдельного архива. Загруженные файлы используются только в рамках текущего сценария обработки, а для стабильной работы применяется ограниченное техническое логирование без избыточного накопления чувствительной информации.",
        },
    ];

    return (
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
            <Box textAlign="center" sx={{ mb: { xs: 4, md: 4.5 } }}>
                <Typography variant="h3" sx={sectionTitleSx}>
                    Частые вопросы
                </Typography>

                <Typography sx={{ ...sectionSubtitleSx, maxWidth: 820 }}>
                    Ключевые вопросы о функционале, форматах работы, отчетности,
                    конфиденциальности и практическом использовании Qarzhy.
                </Typography>
            </Box>

            <Stack spacing={1.15}>
                {faqItems.map((item) => (
                    <Accordion
                        key={item.q}
                        disableGutters
                        elevation={0}
                        sx={{
                            borderRadius: "14px !important",
                            overflow: "hidden",
                            border: "1px solid rgba(148, 163, 184, 0.18)",
                            boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
                            backgroundColor: "#fff",
                            transition: "box-shadow 0.2s ease, border-color 0.2s ease",
                            "&:before": {
                                display: "none",
                            },
                            "&:hover": {
                                borderColor: "rgba(37, 99, 235, 0.20)",
                                boxShadow: "0 14px 28px rgba(15, 23, 42, 0.06)",
                            },
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            sx={{
                                px: { xs: 2, md: 2.4 },
                                py: 0.15,
                                minHeight: 58,
                                "& .MuiAccordionSummary-content": {
                                    my: 1.15,
                                },
                                "& .MuiAccordionSummary-expandIconWrapper": {
                                    color: "#2563eb",
                                },
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 750,
                                    color: "#0f172a",
                                    fontSize: { xs: "0.96rem", md: "0.99rem" },
                                    lineHeight: 1.45,
                                    pr: 1,
                                }}
                            >
                                {item.q}
                            </Typography>
                        </AccordionSummary>

                        <AccordionDetails
                            sx={{
                                px: { xs: 2, md: 2.4 },
                                pt: 0,
                                pb: 2,
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#475569",
                                    lineHeight: 1.72,
                                    fontSize: { xs: "0.91rem", md: "0.95rem" },
                                }}
                            >
                                {item.a}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Stack>
        </Container>
    );
}

export default HomeFaq;